import { InputIcon, InputOptions, NullableTextInput } from '@tempots/beatui'

export function LinkedInInput(options: InputOptions<string | null>) {
  return NullableTextInput({
    before: InputIcon({ icon: 'line-md:linkedin' }),
    placeholder: 'linkedin.com/in/example',
    ...options,
  })
}
